
import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import { useLocale } from '../../localization/LocaleContext';
import Loader from '../../loader/Loader';
import Footer from '../Footer/Footer';
import OnlinePayments from './OnlinePayments';

function OnlinePaymentsMain() {
    const { t } = useLocale();
    useEffect(() => {
        document.title = t('meta.onlinePaymentsTitle')
   }, [t]);
   const[loader, SetLoader] = useState(false)
    useEffect(() =>
    setTimeout(() =>{
        SetLoader(true)
    },1500)[loader]  
    )
    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <OnlinePayments/>
            <Footer/>
        </Fragment>
    )
    
}

export default OnlinePaymentsMain;